import React from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { Modal } from './Modal';
import './SBPModal.css';

export interface SBPModalProps {
  isOpen: boolean;
  onClose: () => void;
  pendingNftId?: string | null;
  /** After successful SBP linking, navigate here (e.g. `/nft/123` from NFT detail). Omit for default redirects. */
  returnPathAfterSbp?: string | null;
}

export const SBPModal: React.FC<SBPModalProps> = ({
  isOpen,
  onClose,
  pendingNftId,
  returnPathAfterSbp,
}) => {
  const navigate = useNavigate();

  const handleLinkSBP = () => {
    onClose();
    navigate('/sbp-linking', {
      state: {
        pendingNftId: pendingNftId || null,
        returnPathAfterSbp: returnPathAfterSbp || null,
      },
    });
  };

  if (!isOpen) {
    return null;
  }

  // Portal + own stacking layer: must sit above any page modal (they all share
  // .modal-overlay z-index 1000) that triggered the SBP-required action.
  return createPortal(
    <div className="sbp-modal-layer">
      <Modal isOpen={isOpen} onClose={onClose} title="Привяжите СБП">
        <div className="sbp-modal-content">
          <p className="sbp-modal-description">
            Откроется форма подключения к СБП: введите код из СМС, чтобы завершить привязку, никаких
            списаний не будет! Так вы сможете легко получать деньги за продажу своих NFT.
          </p>
          <button className="button--primary button--full" onClick={handleLinkSBP}>
            Привязать
          </button>
          <button className="button--secondary button--full" onClick={onClose}>
            Отмена
          </button>
        </div>
      </Modal>
    </div>,
    document.body
  );
};
